var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGeckoboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#geckoboard_svg__a)"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#geckoboard_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#16113A",
  fillRule: "evenodd",
  d: "M12.28 0h15.44C34.501 0 40 5.498 40 12.28v15.44C40 34.501 34.502 40 27.72 40H12.28C5.499 40 0 34.502 0 27.72V12.28C0 5.499 5.498 0 12.28 0",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "geckoboard_svg__c",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12.28 0h15.44C34.501 0 40 5.498 40 12.28v15.44C40 34.501 34.502 40 27.72 40H12.28C5.499 40 0 34.502 0 27.72V12.28C0 5.499 5.498 0 12.28 0",
  clipRule: "evenodd"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#geckoboard_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0FD354",
  d: "m30.052 9.51-.252 1.152v7.463h1.404v10.711a2.38 2.38 0 0 1-2.368 2.369H11.164a2.38 2.38 0 0 1-2.368-2.369v-17.67a2.38 2.38 0 0 1 2.368-2.37h17.21c.567-.02 1.175.273 1.678.714"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#16113A",
  d: "M29.926 9.405c.734.566 1.279 1.425 1.279 2.222v6.812c-1.174 2.495-2.097 4.465-2.37 5.094-1.572 3.354-6.519 7.106-12.178 4.465-5.723-2.662-6.017-8.741-4.403-12.2 1.761-3.794 5.22-5.282 8.595-3.71 1.551.713 2.767 2.243 3.207 3.962.44 1.76.042 3.563-1.11 5.093-.818 1.111-2.39 1.32-3.48.503a2.5 2.5 0 0 1-.483-3.5c.315-.42.294-.713.252-.88-.084-.336-.273-.546-.482-.65-.357-.19-1.153-.545-1.97 1.278-.106.21-1.615 3.878 2.012 5.576 3.102 1.446 5.115-1.153 5.534-2.054z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "geckoboard_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "geckoboard_svg__b",
  width: 100,
  height: 100,
  x: -30,
  y: -30,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0720881 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4298_4008"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4298_4008",
  result: "shape"
})))));
export { SvgGeckoboard as ReactComponent };
export default __webpack_public_path__ + "static/media/geckoboard.503444aa.svg";